import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gsa/afp-component-library';
import { useAppAbility } from '@gsa/afp-shared-ui-utils';
import { OPERATIONS, SUBJECTS } from '../../../utilities/constants';
import AddMakeModelModal from '../add-make-model/index';

const AddMakeModelButton = ({ refetchData = () => {} }) => {
  const ability = useAppAbility();
  const canCreateMakeModel = ability.can(OPERATIONS.Create, SUBJECTS.makeModel);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!canCreateMakeModel) {
    return null;
  }

  return (
    <>
      <Button
        className="float-right"
        variant="outline"
        label="Add make and model"
        leftIcon={{ name: 'add' }}
        data-testid="add-make-model-button"
        onClick={() => setIsModalOpen(true)}
      />
      <AddMakeModelModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        refetchData={refetchData}
      />
    </>
  );
};

AddMakeModelButton.propTypes = {
  refetchData: PropTypes.func,
};

export default AddMakeModelButton;
